const THREE = require('three');
import {ResourcesStorage} from '../../../../../viscomjs/load/ResourcesStorage';
import {maxTexturesType} from '../../../settings/resources';

const _storage = ResourcesStorage.instance();

export const prepareObject = (geometry, material) => {
    return new THREE.Mesh(geometry, material);
};

const textures = [];
const _getTextures = () => {
    if (textures && textures.length > 0) return textures;

    let i;

    for (i = 1; i < maxTexturesType + 1; i++) {
        textures.push(_storage.getItem(`txr-${i}`));
    }

    return textures;
};

const _getTexture = () => {
    const txtrs = _getTextures();
    const t = txtrs.shift();
    txtrs.push(t);
    return t;
};

export const shuffleTextures = () => {
    const txtrs = _getTextures();
    let i;
    let j;
    let t;

    for (i = 1; i < maxTexturesType / 2 + 1; i++) {
        j = Math.ceil(txtrs.length * Math.random());
        if (j > txtrs.length - 1) continue;
        t = txtrs.splice(j, 1);
        txtrs.push(t[0]);
    }
};

export const prepareMaterial = anisotropy => {
    const item = _getTexture();
    const texture = new THREE.Texture(item ? item.data : void 0);
    // const texture = THREE.ImageUtils.loadTexture('./img/include/textures/texture_test.jpg');
    texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
    texture.anisotropy = anisotropy;
    texture.needsUpdate = true;
    // texture.repeat.set(3.5, 1);
    // texture.offset.set(1 / 2, 0);

    return new THREE.MeshBasicMaterial({map: texture /* , side: THREE.DoubleSide*/});
};

export const prepareScreenMaterial = (stateName, anisotropy) => {
    const item = _storage.getItem(`scr-${stateName}`);
    const texture = new THREE.Texture(item ? item.data : void 0);
    texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
    texture.anisotropy = anisotropy;
    texture.needsUpdate = true;

    return new THREE.MeshBasicMaterial({map: texture, alphaTest: 0.1, transparent: true});
};

export const prepareScreenLetterMaterial = (stateName, anisotropy) => {
    const item = _storage.getItem(`ltr-${stateName}`);
    const texture = new THREE.Texture(item ? item.data : void 0);
    texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
    texture.anisotropy = anisotropy;
    texture.needsUpdate = true;

    return new THREE.MeshBasicMaterial({alphaMap: texture, color: new THREE.Color(0, 0, 0)});
};
